import LogoMarqueeWithTitle from "./LogoMarqueeWithTitle";

const LogoMarqueeWithTitleProps = ({ blok }) => {
  return <LogoMarqueeWithTitle sectionTitle={blok.sectionTitle} logos={blok.logos} />;
};

export default LogoMarqueeWithTitleProps;
